<template>
  <div id='prodPopup'>
    <div class='fs-16 fw-700 pb-4'>{{data.title}}</div>
    <div class='mt-16'>
      <div class='lh-18 fs-14 mt-4' v-if='data.star_rating'><span class='fw-600'>Star rating:&nbsp;</span>{{ data.star_rating }}-star accommodation</div>
      <div class='lh-18 fs-14 mt-4' v-if='data.room_type'><span class='fw-600'>Room type:&nbsp;</span>{{ data.room_type }}</div>
      <div class='lh-18 fs-14 mt-4' v-if='data.from'><span class='fw-600'>From:&nbsp;</span>{{ data.from }}</div>
      <div class='lh-18 fs-14 mt-4' v-if='data.to'><span class='fw-600'>To:&nbsp;</span>{{ data.to }}</div>
      <div class='lh-18 fs-14 mt-4' v-if='data.duration'><span class='fw-600'>Duration:&nbsp;</span>{{ data.duration }}</div>
      <div class='lh-18 fs-14 mt-4' v-if='data.check_in'><span class='fw-600'>Check-in:&nbsp;</span>{{ data.check_in }}</div>
      <div class='lh-18 fs-14 mt-4' v-if='data.check_out'><span class='fw-600'>Check-out:&nbsp;</span>{{ data.check_out }}</div>
      <div class='lh-18 fs-14 mt-4' v-if='data.date'><span class='fw-600'>Date:&nbsp;</span>{{ data.date }}</div>
      <div class='lh-18 fs-14 mt-4' v-if='data.type'><span class='fw-600'>Type:&nbsp;</span>{{ data.type }}</div>
    </div>
    <div class='lh-18 fs-14 mt-20' v-if='data.price_included === 0'>
      <span class='fw-600'>Optional Activity</span>
      <template v-if='data.cost_per_person > 0'>:&nbsp;{{currencyDisplay}} <CalculatorDisplayPrice :originalPrice='data.cost_per_person'/> per person</template>
    </div>
    <div class='lh-18 fs-14 mt-20' v-if='data.price_included === 2'>
      <span class='fw-600'>Request to Book</span>
      <template v-if='data.cost_per_person > 0'>:&nbsp;{{currencyDisplay}} <CalculatorDisplayPrice :originalPrice='data.cost_per_person'/> per person</template>
    </div>
    <div class='mt-20 fs-16 lh-24' v-html='data.content'></div>
    <div class='mt-20 fs-16 lh-24' v-html='data.notes'></div>
    <div class='lh-18 fs-14 mt-20' v-if='data.address'><span class='fw-600'>Address:&nbsp;</span>{{ data.address }}</div>
    <div class='mt-20'><img src="https://s3-cdn.designerjourneys.com/static/images/tripplan/powered_by_google.jpg" width='96' height='12' alt="Powered by Google"/></div>
  </div>
</template>

<script>
import { inject, nextTick } from 'vue'
import CalculatorDisplayPrice from '~/components/pages/TripPlanDetail/CalculatorDisplayPrice'

export default {
  name: 'ProductPopup',
  components: { CalculatorDisplayPrice },
  emits:['heightPopup'],
  props: {
    data: { type: Object, default: () => {} }
  },
  data() {
    return {
      contentHeight: 0
    }
  },
  setup() {
    const currencyDisplay = inject('currencyDisplay', 'AU$')
    const typeTripPlan = inject('typeTripPlan', '')

    return {
      currencyDisplay, typeTripPlan
    }
  },
  methods: {
    async getHeight() {
      await nextTick()
      const elm = document.getElementById('prodPopup')
      // console.log('elm',elm.offsetHeight)
      const height = elm.offsetHeight
      this.$emit('heightPopup', height)
    }
  },
  created() {
    this.contentHeight = this.getHeight()
  }
}
</script>

<style scoped>

</style>
